<template>
  <div class="template-of-review wrap-content" style="padding:10px">
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label">评阅书模板</label>
        <Form v-if="!loading" :model="schoolAuditPlanConfig" class="psfamb-form" :label-width="230" ref="pysmbForm" :rules="validateRules">
          <FormItem label="评阅规则名称：" prop="auditPlanName" >
            <Row>
              <Col span="12">
                <Input @on-change="overallJudgeLevelChange" v-model="schoolAuditPlanConfig.auditPlanName" placeholder="必填项" />
              </Col>
            </Row>
          </FormItem>
          <FormItem label="学位类型选择：" prop="degreeType" >
            <Row>
              <Col span="12">
                <Select v-model="schoolAuditPlanConfig.degreeType" filterable @on-change="changeDegreeType()">
                  <Option v-for="item in stuTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </Col>
              <Col span="12"> <strong>（请按不同学位类型分别配置评阅方案模板）</strong></Col>
            </Row>
          </FormItem>
          <FormItem label="请选择整体评价还是分项评价：" prop="partJudgeOpen">
            <Row>
              <Col span="12">
                <RadioGroup v-model="schoolAuditPlanConfig.partJudgeOpen">
                  <Radio label="0">整体评价</Radio>
                  <Radio label="1">分项评价</Radio>
                </RadioGroup>
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <FormItem label="请选择打分模式还是分档模式：" v-if="schoolAuditPlanConfig.partJudgeOpen === '1'">
            <Row>
              <Col span="12">
                <RadioGroup v-model="schoolAuditPlanConfig.partJudgeMode">
                  <Radio label="1">打分模式</Radio>
                  <Radio label="2">分档模式</Radio>
                  <Radio label="3">权重模式</Radio>
                </RadioGroup>
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <Row v-if="schoolAuditPlanConfig.partJudgeOpen === '1'">
            <Col span="24">
              <div style="margin-left:230px">
                <Alert v-if="schoolAuditPlanConfig.partJudgeMode === '1'">针对分项评价指标进行直接打分，不可超过指标最高分限定。</Alert>
                <Alert v-else-if="schoolAuditPlanConfig.partJudgeMode === '2'">针对分项评价指标进行分档选择评价。</Alert>
                <Alert v-else>针对分项评价指标进行百分制打分，所打分数会按权重比例计算出最终得分。</Alert>
              </div>
            </Col>
          </Row>
          <FormItem label="总体评价分档：" prop="overallJudgeLevel" >
            <Row>
              <Col span="12">
                <Input @on-change="overallJudgeLevelChange" v-model="schoolAuditPlanConfig.overallJudgeLevel" placeholder="必填项" />
              </Col>
              <Col span="12"><strong>（注意，分档之间用“|”隔开，例如：优秀|良好）</strong></Col>
            </Row>
          </FormItem>
          <FormItem label="分项评价文字描述：" v-if="schoolAuditPlanConfig.partJudgeOpen === '1'">
            <Row>
              <Col span="12">
                <Input type="textarea" v-model="schoolAuditPlanConfig.partJudgeComment" placeholder="" />
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <FormItem label="评价指标配置：" v-if="schoolAuditPlanConfig.partJudgeOpen === '1'">
            <Row>
              <Col span="12"  style="text-align: center">
                <div class="div-table-border">
                  <table class="table-fxpj">
                    <tbody>
                    <tr>
                      <td width="20%">评价指标</td>
                      <td width="20%" v-if="schoolAuditPlanConfig.partJudgeMode === '3'">比例</td>
                      <td width="20%" v-if="schoolAuditPlanConfig.partJudgeMode === '1'">分数</td>
                      <td width="60%">评价要素</td>
                    </tr>
                    <tr>
                      <td>
                        <textarea v-model="schoolAuditPlanConfig.partNameOne"/>
                      </td>
                      <td v-if="schoolAuditPlanConfig.partJudgeMode !== '2'">
                        <Input v-model="schoolAuditPlanConfig.partScoresOne"  :class="schoolAuditPlanConfig.partJudgeMode === '3' ? 'percent' : ''"/>
                        <span v-if="schoolAuditPlanConfig.partJudgeMode === '3'">%</span>
                      </td>
                      <td>
                        <div style="display:flex;justify-content: space-between;" v-for="(ele, index) in formDynamic.itemsOne" :key="index">
                          <textarea v-model="ele.item" style="width:80%"></textarea>
                          <div>
                            <Icon type="md-add-circle" class="add-circle" @click="handleAddFactor('itemsOne')"/>
                            <Icon type="md-close-circle" class="del-circle" @click="handleDelFactor(index, 'itemsOne', formDynamic.itemsOne)"/>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <textarea v-model="schoolAuditPlanConfig.partNameTwo"/>
                      </td>
                      <td v-if="schoolAuditPlanConfig.partJudgeMode !== '2'">
                        <Input v-model="schoolAuditPlanConfig.partScoresTwo" :class="schoolAuditPlanConfig.partJudgeMode === '3' ? 'percent' : ''"/>
                        <span v-if="schoolAuditPlanConfig.partJudgeMode === '3'">%</span>
                      </td>
                      <td>
                        <div style="display:flex;justify-content: space-between;" v-for="(ele, index) in formDynamic.itemsTwo" :key="index">
                          <textarea v-model="ele.item" style="width:80%"></textarea>
                          <div>
                            <Icon type="md-add-circle" class="add-circle" @click="handleAddFactor('itemsTwo')"/>
                            <Icon type="md-close-circle" class="del-circle" @click="handleDelFactor(index, 'itemsTwo', formDynamic.itemsTwo)"/>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <textarea v-model="schoolAuditPlanConfig.partNameThree"/>
                      </td>
                      <td v-if="schoolAuditPlanConfig.partJudgeMode !== '2'">
                        <Input v-model="schoolAuditPlanConfig.partScoresThree" :class="schoolAuditPlanConfig.partJudgeMode === '3' ? 'percent' : ''"/>
                        <span v-if="schoolAuditPlanConfig.partJudgeMode === '3'">%</span>
                      </td>
                      <td>
                        <div style="display:flex;justify-content: space-between;" v-for="(ele, index) in formDynamic.itemsThree" :key="index">
                          <textarea v-model="ele.item" style="width:80%"></textarea>
                          <div>
                            <Icon type="md-add-circle" class="add-circle" @click="handleAddFactor('itemsThree')"/>
                            <Icon type="md-close-circle" class="del-circle" @click="handleDelFactor(index, 'itemsThree', formDynamic.itemsThree)"/>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <textarea v-model="schoolAuditPlanConfig.partNameFour"/>
                      </td>
                      <td v-if="schoolAuditPlanConfig.partJudgeMode !== '2'">
                        <Input v-model="schoolAuditPlanConfig.partScoresFour" :class="schoolAuditPlanConfig.partJudgeMode === '3' ? 'percent' : ''"/>
                        <span v-if="schoolAuditPlanConfig.partJudgeMode === '3'">%</span>
                      </td>
                      <td>
                        <div style="display:flex;justify-content: space-between;" v-for="(ele, index) in formDynamic.itemsFour" :key="index">
                          <textarea v-model="ele.item" style="width:80%"></textarea>
                          <div>
                            <Icon type="md-add-circle" class="add-circle" @click="handleAddFactor('itemsFour')"/>
                            <Icon type="md-close-circle" class="del-circle" @click="handleDelFactor(index, 'itemsFour', formDynamic.itemsFour)"/>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <textarea v-model="schoolAuditPlanConfig.partNameFive"/>
                      </td>
                      <td v-if="schoolAuditPlanConfig.partJudgeMode !== '2'">
                        <Input v-model="schoolAuditPlanConfig.partScoresFive" :class="schoolAuditPlanConfig.partJudgeMode === '3' ? 'percent' : ''"/>
                        <span v-if="schoolAuditPlanConfig.partJudgeMode === '3'">%</span>
                      </td>
                      <td>
                        <div style="display:flex;justify-content: space-between;" v-for="(ele, index) in formDynamic.itemsFive" :key="index">
                          <textarea v-model="ele.item" style="width:80%"></textarea>
                          <div>
                            <Icon type="md-add-circle" class="add-circle" @click="handleAddFactor('itemsFive')"/>
                            <Icon type="md-close-circle" class="del-circle" @click="handleDelFactor(index, 'itemsFive', formDynamic.itemsFive)"/>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <textarea v-model="schoolAuditPlanConfig.partNameSix"/>
                      </td>
                      <td v-if="schoolAuditPlanConfig.partJudgeMode !== '2'">
                        <Input v-model="schoolAuditPlanConfig.partScoresSix" :class="schoolAuditPlanConfig.partJudgeMode === '3' ? 'percent' : ''"/>
                        <span v-if="schoolAuditPlanConfig.partJudgeMode === '3'">%</span>
                      </td>
                      <td>
                        <div style="display:flex;justify-content: space-between;" v-for="(ele, index) in formDynamic.itemsSix" :key="index">
                          <textarea v-model="ele.item" style="width:80%"></textarea>
                          <div>
                            <Icon type="md-add-circle" class="add-circle" @click="handleAddFactor('itemsSix')"/>
                            <Icon type="md-close-circle" class="del-circle" @click="handleDelFactor(index, 'itemsSix', formDynamic.itemsSix)"/>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <textarea v-model="schoolAuditPlanConfig.partNameSeven"/>
                      </td>
                      <td v-if="schoolAuditPlanConfig.partJudgeMode !== '2'">
                        <Input v-model="schoolAuditPlanConfig.partScoresSeven" :class="schoolAuditPlanConfig.partJudgeMode === '3' ? 'percent' : ''"/>
                        <span v-if="schoolAuditPlanConfig.partJudgeMode === '3'">%</span>
                      </td>
                      <td>
                        <div style="display:flex;justify-content: space-between;" v-for="(ele, index) in formDynamic.itemsSeven" :key="index">
                          <textarea v-model="ele.item" style="width:80%"></textarea>
                          <div>
                            <Icon type="md-add-circle" class="add-circle" @click="handleAddFactor('itemsSeven')"/>
                            <Icon type="md-close-circle" class="del-circle" @click="handleDelFactor(index, 'itemsSeven', formDynamic.itemsSeven)"/>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="分项评价分档：" prop="partJudgeLevel" v-if="schoolAuditPlanConfig.partJudgeOpen === '1'  && schoolAuditPlanConfig.partJudgeMode === '2'">
            <Row>
              <Col span="12">
                <Input v-model="schoolAuditPlanConfig.partJudgeLevel" placeholder="必填项"/>
              </Col>
              <Col span="12"><strong>（注意，分档之间用“|”隔开，例如：优秀|良好）</strong></Col>
            </Row>
          </FormItem>
          <FormItem label="论文评议意见说明：" prop="paperComment" >
            <Row>
              <Col span="12">
                <Input v-model="schoolAuditPlanConfig.paperComment" placeholder="必填项" value="请对论文的学术水平、创新性做出简要评述，包括选题意义、论文创新点、学科知识的掌握、写作规范性和逻辑性等"/>
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <FormItem label="创新点分档设置：" prop="innovationLevel" v-if="doctorId.includes(schoolAuditPlanConfig.degreeType)">
            <Row>
              <Col span="12">
                <Input v-model="schoolAuditPlanConfig.innovationLevel" placeholder="必填项" />
              </Col>
              <Col span="12"><strong>（注意，分数之间用“|”隔开，例如：100|85）</strong></Col>
            </Row>
          </FormItem>
          <FormItem  label="论文不足之处说明：" prop="paperShortComing">
            <Row>
              <Col span="12">
                <Input v-model="schoolAuditPlanConfig.paperShortComing" placeholder="必填项" value="明确指出论文中存在的问题和不足之处，并请提出修改建议"/>
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <FormItem  label="">
            <Row>
              <Col span="24">
                <p v-for="(ele, index) in schoolAuditPlanConfig.overallJudgeLevel.split('|')" :key="index">
                  （ 注意，当总体评价分档为 <Checkbox v-model="subFileArr[index]" @on-change="handleSubFileArr(ele.split('*')[0]), index">{{ele.split('*')[0]}}</Checkbox>，需填写论文不足之处说明且字数不少于
                  <InputNumber style="width: 100px" v-model="essayWordsArr[index]" :disabled="!subFileArr[index]"/> ）
                </p>
              </Col>
              <!-- <Col span="12"></Col> -->
            </Row>
          </FormItem>
          <FormItem label="是否开通总分分数打分：" prop="totalScoreOpen" >
            <Row>
              <Col span="12">
                <RadioGroup v-model="schoolAuditPlanConfig.totalScoreOpen">
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <FormItem v-if="schoolAuditPlanConfig.totalScoreOpen=='1'" label="总体评价文字描述：">
            <Row>
              <Col span="12">
                <Input type="textarea" disabled v-model="schoolAuditPlanConfig.overallComment" placeholder="" />
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <FormItem v-if="schoolAuditPlanConfig.totalScoreOpen=='1'" label="总分分数档设置：" prop="totalScoreLevel" >
            <Row>
              <Col span="12">
                <Input @on-change="allJudgeLevelChange" v-model="schoolAuditPlanConfig.totalScoreLevel" placeholder="必填项" />
              </Col>
              <Col span="12"><strong>（注意，分数之间用“|”隔开，例如：100|85，请保证分数当与总体评价分档数量一致，分数按从大到小排列）</strong></Col>
            </Row>
          </FormItem>
          <FormItem label="答辩决定分档：" prop="replyLevel" >
            <Row>
              <Col span="12">
                <Input v-model="schoolAuditPlanConfig.replyLevel" @on-change="replyListChange" placeholder="必填项" />
              </Col>
              <Col span="12"><strong>（注意，分档之间用“|”隔开，例如“同意答辩|不同意答辩”）</strong></Col>
            </Row>
          </FormItem>
          <FormItem label="答辩意见文字说明：">
            <Row>
              <Col span="12">
                <Input type="textarea" v-model="schoolAuditPlanConfig.replyComment" placeholder="" value="请对是否同意答辩填写您的意见"/>
              </Col>
              <Col span="12"><label></label></Col>
            </Row>
          </FormItem>
          <FormItem label="总分分档与答辩分档关系：" @on-change="overallJudgeLevelChange" prop="totalScoreLevel">
            <Row>
              <Col span="12"  style="text-align: center">
                <div class="div-table-border">
                  <table class="table-fxpj">
                    <tbody>
                    <tr>
                      <td width="30%">总分评价</td>
                      <td width="70%">答辩决定</td>
                    </tr>
                    <tr v-for="(value,key) in judgeReplyMapObject" :key="key">
                      <td>{{key}}</td>
                      <td>
                        <Select multiple v-model="judgeReplyMapObject[key]">
                          <Option v-for="item in replyList" :value="item" :key="item">{{ item }}</Option>
                        </Select>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="是否开放推荐优秀论文：" prop="finePaperOpen">
            <Row>
              <Col span="4">
                <RadioGroup v-model="schoolAuditPlanConfig.finePaperOpen">
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <FormItem label="推荐文字描述：" v-if="schoolAuditPlanConfig.finePaperOpen === '1'">
            <Row>
              <Col span="12">
                <Input v-model="schoolAuditPlanConfig.recommendWord" placeholder="" />
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <FormItem label="优秀论文推荐需满足：" v-if="schoolAuditPlanConfig.finePaperOpen === '1'">
            <Row>
              <Col span="8">
                <CheckboxGroup v-model="meetPaperList">
                  <Checkbox :label="ele" v-for="(ele, index) in schoolAuditPlanConfig.overallJudgeLevel.split('|')" :key="index"></Checkbox>
                </CheckboxGroup>
              </Col>
              <Col span="8"></Col>
            </Row>
          </FormItem>
          <FormItem label="是否填写推荐理由：" prop="recommendReasonOpen" v-if="schoolAuditPlanConfig.finePaperOpen === '1'">
            <Row>
              <Col span="4">
                <RadioGroup v-model="schoolAuditPlanConfig.recommendReasonOpen">
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <FormItem label="推荐优秀分档：" prop="recommendLevel" v-if="schoolAuditPlanConfig.finePaperOpen === '1'">
            <Row>
              <Col span="12">
                <Input v-model="schoolAuditPlanConfig.recommendLevel" placeholder="必填项" />
              </Col>
              <Col span="12"><strong>（注意，分档之间用“|”隔开，例如“推荐|不推荐”）</strong></Col>
            </Row>
          </FormItem>
          <FormItem label="是否开放熟悉程度：" prop="familiarOpen" >
            <Row>
              <Col span="12">
                <RadioGroup v-model="schoolAuditPlanConfig.familiarOpen">
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </Col>
              <Col span="12"></Col>
            </Row>
          </FormItem>
          <FormItem label="熟悉程序分档：" prop="familiarLevel" v-if="schoolAuditPlanConfig.familiarOpen === '1'">
            <Row>
              <Col span="12">
                <Input v-model="schoolAuditPlanConfig.familiarLevel" placeholder="必填项" />
              </Col>
              <Col span="12"><strong>（注意，分档之间用“|”隔开，例如“熟悉|不熟悉”）</strong></Col>
            </Row>
          </FormItem>
          <FormItem  label="论文是否需要专家签名：" prop="reviewSignOpen" >
            <Row>
              <Col span="3">
                <RadioGroup v-model="schoolAuditPlanConfig.reviewSignOpen">
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </Col>
            </Row>
          </FormItem>
        </Form>
        <div style="width:100%;display:flex;justify-content: center;">
          <Button type="primary" @click="save" class="save" style="margin-right:20px">保  存</Button>
          <Button type="default" @click="back" class="save">返  回</Button>
        </div>
      </div>
      <Spin size="large" fix v-if="loading"></Spin>
    </div>
  </div>
</template>

<script>
export default {
  // 评阅模板
  name: 'templateOfReview',
  props: {
    query: ''
  },
  data () {
    // const scoreRule = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('请填写总分分数档设置'));
    //   }
    //   let scoreList = value.split('|');
    //   let last = 1000;
    //   for (const score of scoreList) {
    //     if (isNaN(Number(score))) {
    //       return callback(new Error('请输入数字类型的分数'));
    //     }
    //     if (last < Number(score)) {
    //       return callback(new Error('总分分数档请从大到小设置'));
    //     }
    //     last = score;
    //   }
    //   callback();
    // };
    return {
      validateRules: {
        auditPlanName: [{required: true, message: '请填写模板名', trigger: 'blur'}],
        degreeType: [{required: true, message: '请选择学位类型', trigger: 'blur'}],
        partJudgeOpen: [{required: true, message: '请选择是否开通分项评价', trigger: 'blur'}],
        paperComment: [{required: true, message: '请填写论文评议意见说明', trigger: 'blur'}],
        innovationLevel: [{required: true, message: '请填写创新点分档', trigger: 'blur'}],
        overallJudgeLevel: [{required: true, message: '请填写总体评价分档', trigger: 'blur'}],
        paperShortComing: [{required: true, message: '请填写论文不足之处说明', trigger: 'blur'}],
        totalScoreOpen: [{required: true, message: '请选择是否开通总分分数打分', trigger: 'blur'}],
        replyLevel: [{required: true, message: '请填写答辩决定分档', trigger: 'blur'}],
        finePaperOpen: [{required: true, message: '请选择是否开放推荐优秀论文', trigger: 'blur'}],
        recommendReasonOpen: [{required: true, message: '请选择是否填写推荐理由', trigger: 'blur'}],
        recommendLevel: [{required: true, message: '请填写推荐优秀分档', trigger: 'blur'}],
        familiarLevel: [{required: true, message: '请填写熟悉程序分档', trigger: 'blur'}],
        reviewSignOpen: [{required: true, message: '是否需要显示上传签字', trigger: 'blur'}],
        partJudgeLevel: [{required: true, message: '请填写分项评价分档', trigger: 'blur'}]
      },
      schoolAuditPlanConfig: {
        degreeType: ''
      },
      allCommentArr: [],
      judgeReplyMapObject: {},
      replyList: [],
      stuTypeList: [],
      loading: true,
      doctorId: [],
      curIndex: 1,
      formDynamic: {
        itemsOne: [
          {
            value: '',
            index: 1
          }
        ],
        itemsTwo: [
          {
            value: '',
            index: 1
          }
        ],
        itemsThree: [
          {
            value: '',
            index: 1
          }
        ],
        itemsFour: [
          {
            value: '',
            index: 1
          }
        ],
        itemsFive: [
          {
            value: '',
            index: 1
          }
        ],
        itemsSix: [
          {
            value: '',
            index: 1
          }
        ],
        itemsSeven: [
          {
            value: '',
            index: 1
          }
        ]
      },
      subFileArr: [],
      essayWordsArr: [1, 1, 1, 1, 1, 1],
      meetPaperList: []
    }
  },
  // 在这里调用ajax请求方法
  created () {
    this.getDegreeTpe()
    /* global BaseConfig:true */
    this.BaseConfig = BaseConfig;
  },
  methods: {
    handleSubFileArr (item, index) {
    },
    // 查询数据
    async getDegreeTpe () {
      let url = '/conf/confDegreeType/queryDegreeTypeList'
      let res = await this.post(url)
      if (res.code === 200) {
        this.stuTypeList = res.data
        this.schoolAuditPlanConfig.degreeType = res.data[0].id
        this.search();
        res.data.forEach(element => {
          if (element.name === '博士专业学位' || element.name === '博士学位') {
            this.doctorId.push(element.id)
          }
        });
      }
    },
    search: function () {
      this.loading = true;
      let url;
      if (this.query) {
        url = '/school/schoolAuditPlanConfig/getSchoolAuditPlanConfig/' + this.query
      } else {
        url = '/school/schoolAuditPlanConfig/getDefaultSchoolAuditPlanConfig/' + this.schoolAuditPlanConfig.degreeType
      }
      this.fetch(url).then(res => {
        this.schoolAuditPlanConfig = res.data;
        if (this.schoolAuditPlanConfig.meetPaperRecommend) {
          this.meetPaperList = this.schoolAuditPlanConfig.meetPaperRecommend.split('|')
        }
        if (this.schoolAuditPlanConfig.judgeReplyMap) {
          this.judgeReplyMapObject = JSON.parse(res.data.judgeReplyMap)
        }
        if (this.schoolAuditPlanConfig.replyLevel) {
          this.replyList = res.data.replyLevel.split('|')
        }
        //  回显
        if (this.schoolAuditPlanConfig.overallJudgeLevel) {
          let overallJudgeLevelArray = this.schoolAuditPlanConfig.overallJudgeLevel.split('|')
          for (let i = 0; i < overallJudgeLevelArray.length; i++) {
            this.subFileArr[i] = false
            this.essayWordsArr[i] = 1
          }
        }
        if (this.schoolAuditPlanConfig.evaluationStatusMap && this.schoolAuditPlanConfig.overallJudgeLevel) {
          let overallJudgeLevelArray = this.schoolAuditPlanConfig.overallJudgeLevel.split('|')
          let gradeArray = this.schoolAuditPlanConfig.evaluationStatusMap.split('|')
          for (let i = 0; i < gradeArray.length; i++) {
            let singleGra = gradeArray[i].split('*')
            if (singleGra[1]) {
              for (let j = 0; j < overallJudgeLevelArray.length; j++) {
                if (overallJudgeLevelArray[j] === singleGra[0]) {
                  this.subFileArr[j] = true
                  this.essayWordsArr[j] = singleGra[1]
                }
              }
            }
          }
        }
        if (res.data) {
          if (this.schoolAuditPlanConfig.totalScoreLevel) {
            this.allJudgeLevelChange()
          }
        }
        this.loading = false;
        if (this.schoolAuditPlanConfig.partDetailOne) {
          this.formDynamic.itemsOne = this.schoolAuditPlanConfig.partDetailOne.split('|').map((ele, index) => {
            return {
              item: ele,
              index: index
            }
          })
        }
        if (this.schoolAuditPlanConfig.partDetailTwo) {
          this.formDynamic.itemsTwo = this.schoolAuditPlanConfig.partDetailTwo.split('|').map((ele, index) => {
            return {
              item: ele,
              index: index
            }
          })
        }
        if (this.schoolAuditPlanConfig.partDetailThree) {
          this.formDynamic.itemsThree = this.schoolAuditPlanConfig.partDetailThree.split('|').map((ele, index) => {
            return {
              item: ele,
              index: index
            }
          })
        }
        if (this.schoolAuditPlanConfig.partDetailFour) {
          this.formDynamic.itemsFour = this.schoolAuditPlanConfig.partDetailFour.split('|').map((ele, index) => {
            return {
              item: ele,
              index: index
            }
          })
        }
        if (this.schoolAuditPlanConfig.partDetailFive) {
          this.formDynamic.itemsFive = this.schoolAuditPlanConfig.partDetailFive.split('|').map((ele, index) => {
            return {
              item: ele,
              index: index
            }
          })
        }
        if (this.schoolAuditPlanConfig.partDetailSix) {
          this.formDynamic.itemsSix = this.schoolAuditPlanConfig.partDetailSix.split('|').map((ele, index) => {
            return {
              item: ele,
              index: index
            }
          })
        }
        if (this.schoolAuditPlanConfig.partDetailSeven) {
          this.formDynamic.itemsSeven = this.schoolAuditPlanConfig.partDetailSeven.split('|').map((ele, index) => {
            return {
              item: ele,
              index: index
            }
          })
        }
      }).catch((error) => {
        console.error(error)
        this.loading = false;
      });
    },
    changeDegreeType () {
      if (!this.query) {
        this.search()
      }
    },
    // 获取成绩字符串
    getevaluationStatusMap () {
      let strGrade = ''
      let gradearray = this.schoolAuditPlanConfig.overallJudgeLevel.split('|')
      for (let i = 0; i < this.subFileArr.length; i++) {
        if (this.subFileArr[i] === true) {
          strGrade = strGrade + gradearray[i] + '*' + this.essayWordsArr[i] + '|'
        }
      }
      strGrade = strGrade.slice(0, strGrade.length - 1)
      this.schoolAuditPlanConfig.evaluationStatusMap = strGrade
    },
    // 保存数据
    save () {
      this.getevaluationStatusMap()
      const _self = this;
      return _self.$refs['pysmbForm'].validate().then(res => {
        if (res) {
          if (this.schoolAuditPlanConfig.partJudgeMode === '1' || this.schoolAuditPlanConfig.partJudgeMode === '3') {
            let scoreOne = parseInt(this.schoolAuditPlanConfig.partScoresOne) || 0
            let scoreTwo = parseInt(this.schoolAuditPlanConfig.partScoresTwo) || 0
            let scoreThree = parseInt(this.schoolAuditPlanConfig.partScoresThree) || 0
            let scoreFour = parseInt(this.schoolAuditPlanConfig.partScoresFour) || 0
            let scoreFive = parseInt(this.schoolAuditPlanConfig.partScoresFive) || 0
            let scoreSix = parseInt(this.schoolAuditPlanConfig.partScoresSix) || 0
            let scoreSeven = parseInt(this.schoolAuditPlanConfig.partScoresSeven) || 0
            let totalScore = scoreOne + scoreTwo + scoreThree + scoreFour + scoreFive + scoreSix + scoreSeven
            if (totalScore !== 100) {
              _self.$Message.warning('分项评价指标配置不为100')
            } else {
              if (_self.schoolAuditPlanConfig.partJudgeMode === '1' || (_self.schoolAuditPlanConfig.partJudgeMode === '3')) {
                console.log(1, _self.schoolAuditPlanConfig.partJudgeMode)
                // schoolAuditPlanConfig.partJudgeMode === '2'
                if (_self.schoolAuditPlanConfig.partNameOne) {
                  if (!_self.schoolAuditPlanConfig.partScoresOne) {
                    _self.$Message.error('第一项的指标分值不能为空！');
                    return;
                  }
                }
                if (_self.schoolAuditPlanConfig.partNameTwo) {
                  if (!_self.schoolAuditPlanConfig.partScoresTwo) {
                    _self.$Message.error('第二项的指标分值不能为空！');
                    return;
                  }
                }
                if (_self.schoolAuditPlanConfig.partNameThree) {
                  if (!_self.schoolAuditPlanConfig.partScoresThree) {
                    _self.$Message.error('第三项的指标分值不能为空！');
                    return;
                  }
                }
                if (_self.schoolAuditPlanConfig.partNameFour) {
                  if (!_self.schoolAuditPlanConfig.partScoresFour) {
                    _self.$Message.error('第四项的指标分值不能为空！');
                    return;
                  }
                }
                if (_self.schoolAuditPlanConfig.partNamek) {
                  if (!_self.schoolAuditPlanConfig.partScoresFive) {
                    _self.$Message.error('第五项的指标分值不能为空！');
                    return;
                  }
                }
                if (_self.schoolAuditPlanConfig.partNamek) {
                  if (!_self.schoolAuditPlanConfig.partScoresSix) {
                    _self.$Message.error('第六项的指标分值不能为空！');
                    return;
                  }
                }
                if (_self.schoolAuditPlanConfig.partNamek) {
                  if (!_self.schoolAuditPlanConfig.partScoresSeven) {
                    _self.$Message.error('第七项的指标分值不能为空！');
                    return;
                  }
                }
              }
              if (_self.schoolAuditPlanConfig.partJudgeOpen && _self.schoolAuditPlanConfig.partJudgeOpen === '1') {
                this.schoolAuditPlanConfig.partDetailOne = this.formDynamic.itemsOne.map(ele => {
                  return ele.item
                }).join('|')
                this.schoolAuditPlanConfig.partDetailTwo = this.formDynamic.itemsTwo.map(ele => {
                  return ele.item
                }).join('|')
                this.schoolAuditPlanConfig.partDetailThree = this.formDynamic.itemsThree.map(ele => {
                  return ele.item
                }).join('|')
                this.schoolAuditPlanConfig.partDetailFour = this.formDynamic.itemsFour.map(ele => {
                  return ele.item
                }).join('|')
                this.schoolAuditPlanConfig.partDetailFive = this.formDynamic.itemsFive.map(ele => {
                  return ele.item
                }).join('|')
                this.schoolAuditPlanConfig.partDetailSix = this.formDynamic.itemsSix.map(ele => {
                  return ele.item
                }).join('|')
                this.schoolAuditPlanConfig.partDetailSeven = this.formDynamic.itemsSeven.map(ele => {
                  return ele.item
                }).join('|')
              }
              if (_self.schoolAuditPlanConfig.finePaperOpen === '1') {
                _self.schoolAuditPlanConfig.meetPaperRecommend = _self.meetPaperList.join('|')
              }
              let params = this.schoolAuditPlanConfig;
              params.judgeReplyMap = JSON.stringify(this.judgeReplyMapObject);
              _self.post('/school/schoolAuditPlanConfig/saveSchoolAuditPlanConfig', params).then(res => {
                if (res.code === 200) {
                  this.$Message.success('保存成功!');
                }
              })
            }
          } else {
            if (_self.schoolAuditPlanConfig.partJudgeMode === '1' || (_self.schoolAuditPlanConfig.partJudgeMode === '3')) {
              if (_self.schoolAuditPlanConfig.partNameOne) {
                if (!_self.schoolAuditPlanConfig.partScoresOne) {
                  _self.$Message.error('第一项的指标分值不能为空！');
                  return;
                }
              }
              if (_self.schoolAuditPlanConfig.partNameTwo) {
                if (!_self.schoolAuditPlanConfig.partScoresTwo) {
                  _self.$Message.error('第二项的指标分值不能为空！');
                  return;
                }
              }
              if (_self.schoolAuditPlanConfig.partNameThree) {
                if (!_self.schoolAuditPlanConfig.partScoresThree) {
                  _self.$Message.error('第三项的指标分值不能为空！');
                  return;
                }
              }
              if (_self.schoolAuditPlanConfig.partNameFour) {
                if (!_self.schoolAuditPlanConfig.partScoresFour) {
                  _self.$Message.error('第四项的指标分值不能为空！');
                  return;
                }
              }
              if (_self.schoolAuditPlanConfig.partNamek) {
                if (!_self.schoolAuditPlanConfig.partScoresFive) {
                  _self.$Message.error('第五项的指标分值不能为空！');
                  return;
                }
              }
              if (_self.schoolAuditPlanConfig.partNamek) {
                if (!_self.schoolAuditPlanConfig.partScoresSix) {
                  _self.$Message.error('第六项的指标分值不能为空！');
                  return;
                }
              }
              if (_self.schoolAuditPlanConfig.partNamek) {
                if (!_self.schoolAuditPlanConfig.partScoresSeven) {
                  _self.$Message.error('第七项的指标分值不能为空！');
                  return;
                }
              }
            }
            if (_self.schoolAuditPlanConfig.partJudgeOpen && _self.schoolAuditPlanConfig.partJudgeOpen === '1') {
              this.schoolAuditPlanConfig.partDetailOne = this.formDynamic.itemsOne.map(ele => {
                return ele.item
              }).join('|')
              this.schoolAuditPlanConfig.partDetailTwo = this.formDynamic.itemsTwo.map(ele => {
                return ele.item
              }).join('|')
              this.schoolAuditPlanConfig.partDetailThree = this.formDynamic.itemsThree.map(ele => {
                return ele.item
              }).join('|')
              this.schoolAuditPlanConfig.partDetailFour = this.formDynamic.itemsFour.map(ele => {
                return ele.item
              }).join('|')
              this.schoolAuditPlanConfig.partDetailFive = this.formDynamic.itemsFive.map(ele => {
                return ele.item
              }).join('|')
              this.schoolAuditPlanConfig.partDetailSix = this.formDynamic.itemsSix.map(ele => {
                return ele.item
              }).join('|')
              this.schoolAuditPlanConfig.partDetailSeven = this.formDynamic.itemsSeven.map(ele => {
                return ele.item
              }).join('|')
            }
            if (_self.schoolAuditPlanConfig.finePaperOpen === '1') {
              _self.schoolAuditPlanConfig.meetPaperRecommend = _self.meetPaperList.join('|')
            }
            let params = this.schoolAuditPlanConfig;
            params.judgeReplyMap = JSON.stringify(this.judgeReplyMapObject);
            _self.post('/school/schoolAuditPlanConfig/saveSchoolAuditPlanConfig', params).then(res => {
              if (res.code === 200) {
                this.$Message.success('保存成功!');
              }
            })
          }
        }
      }).catch(() => {
        _self.$Message.error('保存失败');
      });
    },
    overallJudgeLevelChange () {
      this.meetPaperList = []
      const overallJudgeLevelList = this.schoolAuditPlanConfig.overallJudgeLevel.split('|')
      if (typeof this.judgeReplyMapObject === 'undefined') {
        this.judgeReplyMapObject = {}
      }
      for (const i in overallJudgeLevelList) {
        const objKey = overallJudgeLevelList[i]
        if (!this.judgeReplyMapObject.hasOwnProperty(objKey)) {
          this.judgeReplyMapObject[objKey] = []
        }
      }
      for (const key in this.judgeReplyMapObject) {
        if (overallJudgeLevelList.indexOf(key) < 0) {
          delete this.judgeReplyMapObject[key]
        }
      }
      if (this.schoolAuditPlanConfig.totalScoreLevel) {
        this.allJudgeLevelChange()
      }
    },
    allJudgeLevelChange () {
      const overallJudgeLevelList = this.schoolAuditPlanConfig.overallJudgeLevel.split('|')
      const totalScoreLevel = this.schoolAuditPlanConfig.totalScoreLevel.split('|')
      let middle = ''
      let first = ''
      let last = ''
      this.allCommentArr = []
      if (overallJudgeLevelList.length === totalScoreLevel.length) {
        if (overallJudgeLevelList.length <= '1') {
          this.schoolAuditPlanConfig.overallComment = totalScoreLevel[0] + '为' + overallJudgeLevelList[0]
        } else if (overallJudgeLevelList.includes('') || totalScoreLevel.includes('')) {
          this.schoolAuditPlanConfig.overallComment = totalScoreLevel[0] + '为' + overallJudgeLevelList[0]
        } else {
          for (let index in overallJudgeLevelList) {
            first = '总分>=' + totalScoreLevel[1] + '为' + overallJudgeLevelList[0]
            last = '总分<' + totalScoreLevel[overallJudgeLevelList.length - 1] + '为' + overallJudgeLevelList[overallJudgeLevelList.length - 1]
            this.allCommentArr[0] = first
            if (index !== '0' && index !== overallJudgeLevelList.length - 1 + '') {
              if (overallJudgeLevelList.length > 2) {
                let num = parseInt(index)
                middle = totalScoreLevel[index] + '>总分>=' + totalScoreLevel[num + 1] + '为' + overallJudgeLevelList[index]
                this.allCommentArr.push(middle)
              }
            }
          }
          this.allCommentArr.push(last)
          this.schoolAuditPlanConfig.overallComment = '给出百分制总评成绩：' + '\n' + this.allCommentArr.join(';\n');
        }
      } else {
        this.schoolAuditPlanConfig.overallComment = ''
      }
    },
    replyListChange () {
      this.replyList = this.schoolAuditPlanConfig.replyLevel.split('|')
      for (const key in this.judgeReplyMapObject) {
        this.judgeReplyMapObject[key] = []
      }
    },
    back () {
      this.$emit('back');
    },
    handleAddFactor (value) {
      this.curIndex++;
      this.formDynamic[value].push({
        value: '',
        index: this.curIndex
      });
    },
    handleDelFactor (index, value, ele) {
      if (ele.length > 1) {
        this.formDynamic[value].splice(index, 1)
      } else {
        this.$Message.warning('请至少保留一条评价要素')
      }
    }
  }
}
</script>

<style lang="less">
</style>
<style lang="less" scoped>
  strong{
    color: @text-color;
    opacity: 0.9
  }
  /deep/.kh-form-item-error-tip {
    position: absolute;
    top: 6px;
    color: @error-color;
    right: calc(50% + 10px);
  }
  /deep/.kh-input[disabled]{
    color: #515a6e
  }
  /deep/textarea.kh-input {
    font-size: 12px;
  }
  .template-of-review{
    .div-table-border{
      border: @border-width-base @border-style-base @border-color-base;
      border-radius: @border-radius-small;
    }
    /deep/.table-fxpj{
      border-spacing: 0;
      width: 100%;
      tr {
        td {
          border-bottom: @border-width-base @border-style-base @border-color-base;
          text-align: left;
          padding: 0 0 0 8px;
          input {
            line-height: 33px;
            height: 33px;
            border: 0 none;
            margin-left: -8px;
            text-indent: 8px;
            width: calc(100% + 6px);
            &:focus {
              border-color: #62bfe1;
              outline: 0;
              box-shadow: 0 0 0 2px rgba(@base-color, .2);
            }
          }
          textarea {
            line-height: 1.15;
            height: 40px;
            border: 0 none;
            margin-left: -8px;
            padding-left: 8px;
            padding-top: 4px;
            width: calc(100% + 6px);
            float: left;
            &:focus {
              border-color: #62bfe1;
              outline: 0;
              box-shadow: 0 0 0 2px rgba(@base-color, .2);
            }
          }
        }
        &:last-child td{
          border-bottom: 0 none;
        }
      }
    }
  }
  .add-circle {
    font-size: 20px;
    color: #1890ff;
    cursor: pointer;
  }
  .del-circle {
    font-size: 20px;
    color: #ed4014;
    cursor: pointer;
  }
  .wrap-content {
    padding: 0;
  }
  .percent {
    width: 80%
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/configManage/templateOfReview.vue